<h1 mat-dialog-title><fa-icon icon="upload" class="mr-4"></fa-icon> {{ data.teitl | translate }}</h1>

<div mat-dialog-content>
  <button type="button" mat-raised-button color="primary" (click)="dewis()" class="margin-dde-1em" [disabled]="ynArbed">
    <fa-icon icon="upload" class="mr-4"></fa-icon>
    <span>{{ "ui.dewis" | translate }}</span>
  </button>

  <mat-list class="container-ffeiliau">
    @for (ffeil of ffeiliau; track ffeil) {
      <mat-list-item>
        <div class="flex-container">
          @if (ffeil.statws == 0) {
            <div class="margin-dde">
              <fa-icon icon="clock" class="mr-4" size="small"></fa-icon>
              <span>{{ "ui.disgwyluwchlwytho" | translate }}</span>
            </div>
          }
          <div class="margin-dde">
            <fa-icon icon="file" class="mr-4" size="small"></fa-icon>
            <span mat-line>{{ ffeil.enw }}</span>
          </div>

          @if (ffeil.statws == 1) {
            <div class="margin-dde">
              <mat-progress-bar class="llwytho-ffeil" mode="buffer"></mat-progress-bar>
            </div>
          }
          @if (ffeil.statws == 2) {
            <div class="margin-dde">
              <fa-icon icon="exclamation-triangle" class="mr-4" size="small"></fa-icon>
              <span>{{ "ui.gwalluwchlwytho" | translate }}</span>
            </div>
          }
          @if (ffeil.statws == 3) {
            <div class="margin-dde">
              <fa-icon icon="check" class="mr-4" size="small"></fa-icon>
              <span>{{ "ui.llwyddiantuwchlwytho" | translate }}</span>
            </div>
          }
          @if (!ynArbed && ffeil.statws != 3) {
            <div>
              <fa-icon class="cursor-pointer" icon="times" size="small" (click)="dileu(ffeil)"></fa-icon>
            </div>
          }
        </div>
      </mat-list-item>
    }
  </mat-list>

  <input type="file" id="ffeiliauInput" name="ffeiliauInput" multiple="multiple" accept="{{ data.accept }}" style="display: none" />
</div>
<div mat-dialog-actions>
  @if (ffeiliau.length > 0) {
    <button mat-raised-button color="primary" (click)="uwchlwytho()" [disabled]="ynArbed">
      @if (ynArbed) {
        <mat-icon>
          <mat-spinner color="accent" diameter="20"></mat-spinner>
        </mat-icon>
      }
      {{ "ui.uwchlwytho" | translate }}
    </button>
  }
  <button mat-flat-button (click)="cau()">{{ "ui.ynol" | translate }}</button>
</div>
